import { getReportMailingBaseFormShape } from '@common';
import type { TFunction } from 'i18next';
import { z } from 'zod';

const buildAddReportMailingFormSchema = (t: TFunction<'common'>) =>
  z.object({ label: getReportMailingBaseFormShape(t).label });

export type AddReportMailingFormSchemaType = ReturnType<
  typeof buildAddReportMailingFormSchema
>;

export const getAddReportMailingFormSchema = (
  t: TFunction<'common'>
): AddReportMailingFormSchemaType => buildAddReportMailingFormSchema(t);
